import type { CardDesignTokens, CardTokenSections } from '@primeuix/themes/types/card';

// Brand guide Card: radius-xlarge (20px), padding space-small (24px), 1px
// `neutral-lighter` border (cleverly-overrides.scss — PrimeNG cards have no border
// token), no resting shadow. Title = app-card-title 18/800 in `wine` (O2/O12).
export const root: CardTokenSections.Root = {
    background: '{content.background}',
    borderRadius: '{borderRadius.xl}',
    color: '{text.color}',
    shadow: 'none'
};

export const body: CardTokenSections.Body = {
    padding: '24px',
    gap: '16px'
};

export const caption: CardTokenSections.Caption = {
    gap: '4px'
};

export const title: CardTokenSections.Title = {
    fontSize: '1.125rem',
    fontWeight: '800'
};

export const subtitle: CardTokenSections.Subtitle = {
    color: '{text.mutedColor}'
};

export default {
    root,
    body,
    caption,
    title,
    subtitle
} satisfies CardDesignTokens;
